import {skipToken} from '@reduxjs/toolkit/query';

import {isNotNil} from 'ramda';

import {useGetAuthorizationProfilesQuery, useGetAuthorizationsQuery} from '@dms/api/security';
import {useIsLicenceEnabled, useTenant} from '@dms/shared';

const HYUNDAI_AUTHORIZATION_NAME = 'Hyundai CZE';

/**
 * Resolves whether the tenant has an active Hyundai authorization profile.
 * The underlying queries fire only for users who could ever see Hyundai reporting
 * (workshop licence), so the check is free for everyone else.
 */
export function useHasActiveHyundaiAuthorizationProfile() {
  const {tenant} = useTenant();
  const {isWorkshopModuleEnabled} = useIsLicenceEnabled();

  const tenantId = tenant?.id;
  const isEntitledToQuery = isWorkshopModuleEnabled && isNotNil(tenantId);
  const queryArg = isEntitledToQuery ? {'x-tenant': tenantId} : skipToken;

  const authorizationsQuery = useGetAuthorizationsQuery(queryArg);
  const authorizationProfilesQuery = useGetAuthorizationProfilesQuery(queryArg);

  const hyundaiAuthorizationId = authorizationsQuery.data?.find(
    (authorization) => authorization?.name === HYUNDAI_AUTHORIZATION_NAME
  )?.id;

  const hasActiveHyundaiAuthorizationProfile =
    isNotNil(hyundaiAuthorizationId) &&
    (authorizationProfilesQuery.data?.some(
      (profile) => profile?.authorizationId === hyundaiAuthorizationId && profile?.isActive
    ) ??
      false);

  return {
    hasActiveHyundaiAuthorizationProfile,
    isLoading: authorizationsQuery.isLoading || authorizationProfilesQuery.isLoading,
    isError: authorizationsQuery.isError || authorizationProfilesQuery.isError,
  };
}
